module.exports = __webpack_public_path__ + "assets/img/已签收.6ed1180d.svg";